import { render } from "./PathFollow.vue?vue&type=template&id=0146dac5&scoped=true"
import script from "./PathFollow.vue?vue&type=script&lang=js"
export * from "./PathFollow.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0146dac5"

export default script